module.exports = __webpack_public_path__ + "static/media/banner_low_quality.a12d6832.png";